// Incremental runtime stats helpers shared by main-thread and worker compile flows.
// Example: normalize compiler stats before logging them in runtime diagnostics.
import type { LuisIncrementalCompileStats } from '@lentystyle/compiler/incremental'
import type { LuisIncrementalPerf } from './context-types'

// Normalize incremental stats shape for runtime logging.
export function normalizeIncrementalStats(stats: LuisIncrementalCompileStats): LuisIncrementalPerf {
  // Return normalized stats object for runtime diagnostics.
  return {
    mode: stats.mode,
    totalBlocks: stats.totalBlocks,
    reusedBlocks: stats.reusedBlocks,
    renderedBlocks: stats.renderedBlocks,
    parser: {
      totalSegments: stats.parser.totalSegments,
      reusedSegments: stats.parser.reusedSegments,
      parsedSegments: stats.parser.parsedSegments,
    },
  }
}
